import { render } from "./tender_letter.vue?vue&type=template&id=7b2ff42e"
import script from "./tender_letter.vue?vue&type=script&lang=js"
export * from "./tender_letter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/letter/tender_letter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b2ff42e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b2ff42e', __exports__)) {
    console.log('reload')
    api.reload('7b2ff42e', __exports__)
  }
  
  module.hot.accept("./tender_letter.vue?vue&type=template&id=7b2ff42e", () => {
    console.log('re-render')
    api.rerender('7b2ff42e', render)
  })

}


export default __exports__